import { useEffect } from 'react'
import { SearchableInfiniteList } from '$common/searchable-list'
import { WithAppBarAndActionButton } from './with-appbar-and-action-button'
import {
  SearchableInfiniteListPageInnerProps,
  SearchableInfiniteListPageOuterProps,
} from './searchable-list-page.types'
import { nothing } from '$func/utils'

export function withSearchableInfiniteListPage<
  Item,
  FetchParams,
  SearchParams,
>({
  appBarTitle,
  SkeletonItem,
  EmptyStateComponent,
  itemSize = 57,
  fetchHook,
  searchHook,
  actionButtonText,
  actionButtonIcon,
  onActionButtonClick = nothing,
  subHeaderText,
  overscanCount = 3,
  onBack,
}: SearchableInfiniteListPageOuterProps<Item, FetchParams, SearchParams>) {
  function SearchableInfiniteListPage({
    hideActionButton,
    getSubHeaderText,
    fetchHookParams,
    getSearchHookParams,
    ListItem,
  }: SearchableInfiniteListPageInnerProps<Item, FetchParams, SearchParams>) {
    const { items, hasMoreItemToLoad, loadMore, loading } =
      fetchHook(fetchHookParams)

    useEffect(() => {
      loadMore()
    }, [])

    return (
      <WithAppBarAndActionButton
        appBarTitle={appBarTitle}
        loading={loading}
        actionButtonText={actionButtonText}
        actionButtonIcon={actionButtonIcon}
        hideActionButton={hideActionButton}
        onActionButtonClick={onActionButtonClick}
        subHeaderText={
          getSubHeaderText
            ? getSubHeaderText(items?.length || 0, hasMoreItemToLoad)
            : subHeaderText
        }
        onBack={onBack}
      >
        {(listHeight: number, searchQuery: string) => (
          <SearchableInfiniteList
            items={items}
            height={listHeight}
            ListItem={ListItem}
            SkeletonItem={SkeletonItem}
            EmptyStateComponent={EmptyStateComponent}
            itemSize={itemSize}
            loadMore={loadMore}
            hasMoreItemToLoad={hasMoreItemToLoad}
            searchQuery={searchQuery}
            searchHook={searchHook}
            searchHookParams={getSearchHookParams(
              searchQuery,
              items,
              hasMoreItemToLoad,
            )}
            overscanCount={overscanCount}
            loading={loading}
          />
        )}
      </WithAppBarAndActionButton>
    )
  }

  SearchableInfiniteListPage.defaultProps = {
    hideActionButton: false,
    getSubHeaderText: null,
  }

  return SearchableInfiniteListPage
}
